module.exports = __webpack_public_path__ + "static/media/ic_invest_hundered_mf.9beb19e9.svg";